export const stripe_sky = 'pk_test_51QjwFxRt1VqMwc5bgWBSYz13Fyn73xmphu9jfhwGUlzbZzSbwpS6LuuL2kXXDYSx6ILtzkHO15R0jnkEkXWPuXSb00cin5BCN7'
// import axios from 'axios'
const local = 'http://localhost:5000'
const production = 'https://hawkers-api.onrender.com'

let base_url = ''
let mode = 'pro'

if (mode === 'pro'){
    base_url = production
}else{
    base_url = local
}

export { base_url, mode}